export const isAxiosTimeoutError = (err: any): err is Error => {
    if (!(err instanceof Error)) {
        return false;
    }

    return err.message.includes('timeout of');
};
